import { render, staticRenderFns } from "./ModifySalePrice.vue?vue&type=template&id=64839c7a&"
import script from "./ModifySalePrice.vue?vue&type=script&lang=ts&"
export * from "./ModifySalePrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports